import React, { useState, useEffect } from "react";
 
import {
  Box,
  TextField,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  IconButton,
  Modal,
  Fade,
  Backdrop,
  InputAdornment,
  Tooltip,
  CircularProgress,
  Divider,
  AppBar,
  Toolbar,
  Badge,
  styled,
  useTheme,
  useMediaQuery,
  Card,
  CardContent,
  Select,
  MenuItem,
} from "@mui/material";
import LeftToolbar from "./LeftToolbar";
import CloseIcon from "@mui/icons-material/Close";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
import NotificationsIcon from "@mui/icons-material/Notifications";
import EventIcon from "@mui/icons-material/Event";
import VisibilityIcon from "@mui/icons-material/Visibility";
import LinkIcon from "@mui/icons-material/Link";
import Footer from "./Footer";
import { alpha } from "@mui/material";
import ConfirmationDialog from "./ConfirmationDialog";
import NotificationSnackbar from "./NotificationBar";
import Pagination from "@mui/material/Pagination";
import Chip from "@mui/material/Chip";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import axios from "axios";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import UploadQuestionsButton from "./UploadQuestionsButton";
const api = axios.create({ withCredentials: true });
const MainContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  minHeight: "100vh",
  backgroundColor: "#f5f7fa",
});

const MainContent = styled(Box)(({ theme, $collapsed }) => ({
  flexGrow: 1,
  padding: theme.spacing(3),
  marginLeft: $collapsed ? "80px" : "280px",
  transition: theme.transitions.create("margin", {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.standard,
  }),
  [theme.breakpoints.down("sm")]: {
    marginLeft: 0,
    padding: theme.spacing(2),
  },
}));

const ResponsiveTableContainer = styled(TableContainer)(({ theme }) => ({
  borderRadius: "12px",
  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
  overflowX: "auto",
  [theme.breakpoints.down("sm")]: {
    borderRadius: "8px",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:hover": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const ModernTableCell = styled(TableCell)(({ theme }) => ({
  padding: theme.spacing(2),
  borderBottom: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
  "&:first-of-type": {
    borderLeft: `4px solid ${theme.palette.primary.main}`,
  },
  [theme.breakpoints.down("sm")]: {
    padding: theme.spacing(1.5),
  },
}));

function RequestUserFeedBacks() {
  const [surveys, setSurveys] = useState([]);
  const [module, setModule] = useState("");
  const [title, setTitle] = useState("");
  const [categories, setCategories] = useState([]);
  const [selectedSurvey, setSelectedSurvey] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [surveysPerPage] = useState(5);
  const [selectedQuestion, setSelectedQuestion] = useState(null);
  const [selectedQuestionForAnswers, setSelectedQuestionForAnswers] =
    useState(null);
  const [isAddAnswersModalOpen, setIsAddAnswersModalOpen] = useState(false);
  const [openSurveyModal, setOpenSurveyModal] = useState(false);
  const [openQuestionModal, setOpenQuestionModal] = useState(false);
  const [surveyQuestions, setSurveyQuestions] = useState([]);
  const [openEditQuestionModal, setOpenEditQuestionModal] = useState(false);
  const [openViewQuestionsModal, setOpenViewQuestionsModal] = useState(false);
  const [openAnswersModal, setOpenAnswersModal] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [surveyToDelete, setSurveyToDelete] = useState(null);
  const [openConfirm, setOpenConfirm] = useState(false);

  const [editingQuestion, setEditingQuestion] = useState(null);
  const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
  const [questionToDelete, setQuestionToDelete] = useState(null);
  const [loadingAction, setLoadingAction] = useState(false);

  // State variables
  const [surveyData, setSurveyData] = useState(null);
  const [groupedQuestions, setGroupedQuestions] = useState([]);
  const [loadingQuestions, setLoadingQuestions] = useState(false);
  const [newQuestionAnswers, setNewQuestionAnswers] = useState([
    { id: 1, text: "" },
  ]);
  const [formErrors, setFormErrors] = useState({
    title: false,
    module: false,
    content: false,
  });
  const handleSnackbarOpen = (message, severity = "success") => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };
  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handleCreateSurveyQuestion = async () => {
    // Validate inputs
    if (!title.trim()) {
      handleSnackbarOpen("Question text is required", "error");
      return;
    }

    const validAnswers = newQuestionAnswers.filter((a) => a.text.trim());
    if (validAnswers.length < 1) {
      handleSnackbarOpen("At least one answer option is required", "error");
      return;
    }

    try {
      setLoading(true);

      const requestBody = {
        surveyId: selectedSurvey?.id || 0,
        questionText: title,
        questionType: "SINGLE CHOICE",
        isRequired: true,
        moduleId: selectedSurvey?.moduleId || null,
        answerOptions: validAnswers.map((answer, index) => ({
          optionText: answer.text,
          isActive: true,
          displayOrder: index + 1,
        })),
      };

      console.log("Creating question with payload:", requestBody);

      const response = await fetch("/api/support/survey-question", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify(requestBody),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Failed to create question");
      }

      // Update local state
      const newQuestion = {
        id: data.questionId,
        title: requestBody.questionText,
        answers: requestBody.answerOptions,
        answerType: requestBody.questionType,
        status: "Active",
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString(),
      };

      setSurveyQuestions((prev) => [...prev, newQuestion]);

      if (selectedSurvey) {
        setSelectedSurvey((prev) => ({
          ...prev,
          questions: [...prev.questions, newQuestion],
        }));
      }

      handleSnackbarOpen("Question created successfully!", "success");
    } catch (error) {
      console.error("Creation error:", error);
      handleSnackbarOpen(
        error.message.includes("Network")
          ? "Network error - please try again"
          : error.message,
        "error"
      );
    } finally {
      setLoading(false);
      setOpenQuestionModal(false);
      setTitle("");
      setNewQuestionAnswers([{ id: 1, text: "" }]);
    }
  };

  const [collapsed, setCollapsed] = useState(false);
  const [selectedMenu, setSelectedMenu] = useState("surveys");
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const [surveyForm, setSurveyForm] = useState({
    title: "",
    description: "",
    module: "",
    startDate: "",
    endDate: "",
  });

  const [questionForm, setQuestionForm] = useState({
    title: "",
    module: "",
    answers: [{ id: 1, text: "" }],
  });

  const [editQuestionForm, setEditQuestionForm] = useState({
    title: "",
    module: "",
    answers: [
      {
        id: 1,
        text: "",
        isCorrect: false,
      },
    ],
  });

  const [answers, setAnswers] = useState([{ id: 1, text: "" }]);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      setLoading(true);
      try {
        const categoriesResponse = await axios.get("/api/support/categories");
        setCategories(categoriesResponse.data);
        const surveysResponse = await axios.get("/api/support/surveys");
        setSurveys(
          surveysResponse.data.surveys?.map((s) => ({
            ...s,
            questions: s.questions || [],
          })) || []
        );
      } catch (error) {
        console.error("Error fetching data:", error);
        handleSnackbarOpen("Failed to load data", "error");
      } finally {
        setIsLoading(false);
        setLoading(false);
      }
    };

    fetchData();
  }, []);
  const handleAddNewAnswer = () => {
    setNewQuestionAnswers([
      ...newQuestionAnswers,
      { id: Date.now(), text: "" },
    ]);
  };

  const handleRemoveNewAnswer = (answerId) => {
    if (newQuestionAnswers.length > 1) {
      setNewQuestionAnswers(
        newQuestionAnswers.filter((answer) => answer.id !== answerId)
      );
    } else {
      handleSnackbarOpen("At least one answer option is required", "error");
    }
  };

  const handleNewAnswerTextChange = (id, newText) => {
    const updatedAnswers = newQuestionAnswers.map((answer) =>
      answer.id === id ? { ...answer, text: newText } : answer
    );
    setNewQuestionAnswers(updatedAnswers);
  };

  const handleSurveyFormChange = (e) => {
    const { name, value } = e.target;
    setSurveyForm((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (value) {
      setFormErrors({ ...formErrors, [name]: false });
    }
  };

  const handleEditQuestionFormChange = (e) => {
    const { name, value } = e.target;
    setEditQuestionForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleAnswerTextChange = (id, value) => {
    setEditQuestionForm((prev) => ({
      ...prev,
      answers: prev.answers.map((answer) =>
        answer.id === id ? { ...answer, text: value } : answer
      ),
    }));
  };

  const handleAddAnswer = () => {
    const newAnswer = {
      id: Date.now(),
      text: "",
      isCorrect: false,
    };

    if (openEditQuestionModal) {
      setEditQuestionForm((prev) => ({
        ...prev,
        answers: [...prev.answers, newAnswer],
      }));
    }

    if (openAnswersModal) {
      setAnswers((prev) => [...prev, newAnswer]);
    }
  };

  const handleRemoveAnswerInEditModal = (answerId) => {
    setEditQuestionForm((prev) => ({
      ...prev,
      answers: prev.answers.filter((answer) => answer.id !== answerId),
    }));
  };
  const handleRemoveAnswerInManageModal = (answerId) => {
    setAnswers((prev) => prev.filter((answer) => answer.id !== answerId));
  };
  const handleRemoveAnswer = (answerId) => {
    setAnswers((prev) => prev.filter((answer) => answer.id !== answerId));
  };

  const handleCreateSurvey = async () => {
    if (!surveyForm.title || !surveyForm.startDate || !surveyForm.endDate) {
      handleSnackbarOpen("Title and dates are required", "error");
      return;
    }
    const userToken = localStorage.getItem("userToken");
    if (!userToken) {
      handleSnackbarOpen("Unauthorized. Please login first.", "error");
      return;
    }

    try {
      setLoading(true);

      const payload = {
        title: surveyForm.title,
        descriptions: surveyForm.description,
        moduleId: surveyForm.module || null,
        startOn: surveyForm.startDate,
        endOn: surveyForm.endDate,
      };

      const res = await fetch("/api/support/survey", {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Authorization: `${userToken}`,
        },
        body: JSON.stringify(payload),
      });
      const data = await res.json();
      if (!res.ok) {
        throw new Error(data.message || "Failed to create survey");
      }

      const newSurvey = data.result || {
        ...payload,
        id: Date.now().toString(),
      };

      setSurveys((prev) => [
        ...prev,
        {
          ...newSurvey,
          moduleName:
            categories.find((c) => c.id === surveyForm.module)?.categoryName ||
            "",
          createdAt: new Date().toISOString(),
        },
      ]);
      handleSnackbarOpen("Survey created successfully!", "success");
      setSurveyForm({
        title: "",
        description: "",
        module: "",
        startDate: "",
        endDate: "",
      });
      setOpenSurveyModal(false);
    } catch (error) {
      console.error("Error creating survey:", error);
      handleSnackbarOpen(error.message || "Failed to create survey", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleEditSurvey = async () => {
    if (!surveyForm.title || !surveyForm.startDate || !surveyForm.endDate) {
      handleSnackbarOpen("Title and dates are required", "error");
      return;
    }

    const userToken = localStorage.getItem("userToken");
    if (!userToken) {
      handleSnackbarOpen("Unauthorized. Please login first.", "error");
      return;
    }

    try {
      setLoading(true);

      const payload = {
        title: surveyForm.title,
        descriptions: surveyForm.description,
        moduleId: surveyForm.module || null,
        startOn: surveyForm.startDate,
        endOn: surveyForm.endDate,
      };

      const res = await fetch(`/api/support/survey/${selectedSurvey.id}`, {
        method: "PUT",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Authorization: `${userToken}`,
        },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.message || "Failed to update survey");
      }
      const updatedSurveys = surveys.map((survey) =>
        survey.id === selectedSurvey.id
          ? {
              ...survey,
              ...payload,
              updatedAt: new Date().toISOString(),
            }
          : survey
      );

      setSurveys(updatedSurveys);
      setOpenSurveyModal(false);
      handleSnackbarOpen("Survey updated successfully", "success");
    } catch (error) {
      console.error("Error updating survey:", error);
      handleSnackbarOpen(error.message || "Failed to update survey", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteClick = (survey) => {
    setSurveyToDelete(survey);
    setOpenSurveyModal(false);
    setOpenConfirm(true);
  };
  const handleDeleteConfirm = async () => {
    if (!surveyToDelete) return;

    setLoading(true);
    try {
      const res = await fetch(`/api/support/survey/${surveyToDelete.id}`, {
        method: "DELETE",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
      });
      const data = await res.json();
      if (!res.ok) {
        throw new Error(data.message || "Failed to delete survey");
      }

      setSurveys((prev) => prev.filter((s) => s.id !== surveyToDelete.id));
      handleSnackbarOpen("Survey deleted successfully", "success");
    } catch (error) {
      console.error("Error deleting survey:", error);
      handleSnackbarOpen(error.message || "Failed to delete survey", "error");
    } finally {
      setLoading(false);
      setOpenConfirm(false);
      setSurveyToDelete(null);
    }
  };

  const handleDeleteSurveyQuestion = async () => {
    if (!questionToDelete) {
      handleSnackbarOpen(
        "Question selected for deletion is not found!",
        "error"
      );
      setDeleteConfirmOpen(false);
      return;
    }

    try {
      const res = await fetch(
        `/api/support/survey-question/${questionToDelete.QuestionId}`,
        {
          method: "DELETE",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const data = await res.json();
      if (!res.ok) {
        throw new Error(data.message || "Failed to delete survey");
      }

      handleSnackbarOpen("Question deleted successfully!", "success");
      setDeleteConfirmOpen(false);
      setQuestionToDelete(null);
      // Optionally refresh questions list here
    } catch (error) {
      console.error("Error deleting question:", error);
      handleSnackbarOpen(error.message || "Failed to delete question", "error");
      setDeleteConfirmOpen(false);
    }
  };
  const handleDeleteSurveyQuestionClick = (question) => {
    setQuestionToDelete(question);
    setDeleteConfirmOpen(true);
    setOpenViewQuestionsModal(false);
  };

  const handleEditQuestion = (question) => {
    console.log("Editing question:", question);
    setEditingQuestion(question);
    setOpenEditQuestionModal(true);
    setOpenViewQuestionsModal(false);
  };

  const handleUpdateQuestion = async (editedData) => {
    setLoading(true);
    try {
      // Validate all required fields
      if (!editedData?.questionText?.trim()) {
        throw new Error("Question text is required");
      }
      if (!editedData?.moduleId) {
        throw new Error("Module selection is required");
      }
      if (!editedData?.options?.length) {
        throw new Error("At least one answer option is required");
      }
      if (editedData.options.some((opt) => !opt.optionText?.trim())) {
        throw new Error("All answer options must have text");
      }

      const requestBody = {
        questionText: editedData.questionText,
        questionType: "Radio",
        isRequired: true,
        moduleId: editedData.moduleId,
        QuestionId: editedData.QuestionId,
        options: editedData.options.map((opt) => ({
          optionText: opt.optionText,
          isCorrect: opt.isCorrect || false,
        })),
      };

      const response = await fetch(
        `/api/support/survey-question/${editedData.QuestionId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        }
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Failed to update question");
      }

      // On success
      handleSnackbarOpen(
        data.message || "Question updated successfully",
        "success"
      );
      setOpenEditQuestionModal(false);
      // Refresh your questions list
      fetchSurveyQuestions(selectedSurvey.SurveyId);
    } catch (error) {
      console.error("Error updating questionf:", error);
      handleSnackbarOpen(
        error.message || "An error occurred while updating the questionf",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  const handleSaveAnswers = async () => {
    const emptyAnswers = answers.filter((answer) => !answer.text.trim());
    if (emptyAnswers.length > 0) {
      handleSnackbarOpen("All answer options must have text", "error");
      return;
    }

    try {
      setLoading(true);
      await new Promise((resolve) => setTimeout(resolve, 600));

      const updatedSurveyQuestions = surveyQuestions.map((surveyQuestion) => {
        if (surveyQuestion.id === selectedQuestionForAnswers.id) {
          return {
            ...surveyQuestion,
            answers: [...answers],
            answerType: "radio",
          };
        }
        return surveyQuestion;
      });

      setSurveyQuestions(updatedSurveyQuestions);
      setIsAddAnswersModalOpen(false);
      handleSnackbarOpen("Answer options saved successfully", "success");
    } catch (error) {
      console.error("Error saving answers:", error);
      handleSnackbarOpen("Failed to save answer options", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteQuestion = async (questionId) => {
    try {
      setLoading(true);

      const updatedSurveys = surveys.map((survey) => {
        if (survey.id === selectedSurvey.id) {
          return {
            ...survey,
            questions: survey.questions?.filter((q) => q.id !== questionId),
            updatedAt: new Date().toISOString(),
          };
        }
        return survey;
      });

      setSurveys(updatedSurveys);
      setOpenViewQuestionsModal(false);
      handleSnackbarOpen("Question deleted successfully", "success");
    } catch (error) {
      console.error("Error deleting question:", error);
      handleSnackbarOpen("Failed to delete question", "error");
    } finally {
      setLoading(false);
    }
  };

  const filteredSurveys = surveys.filter(
    (survey) =>
      survey.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
      survey.descriptions.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const handleOpenCreateSurveyModal = () => {
    setSelectedSurvey(null);
    setSurveyForm({
      title: "",
      description: "",
      startDate: "",
      endDate: "",
    });
    setOpenSurveyModal(true);
  };

  const handleOpenEditSurveyModal = (survey) => {
    setSelectedSurvey(survey);
    console.log("Helooooooooooooooooooooooooooo",survey.id);
    setSurveyForm({
      title: survey.title || "",
      module: survey.module || "",
      description: survey.descriptions || "",
      startDate: survey.startOn || "",
      endDate: survey.endOn || "",
    });
    setOpenSurveyModal(true);
  };
  //
  const handleOpenQuestionModal = (survey) => {
    if (!survey) {
      handleSnackbarOpen("No survey selected", "error");
      return;
    }

    setSelectedSurvey(survey);
    setQuestionForm({
      title: "",
      module: "",
      answers: [{ id: 1, text: "" }],
    });
    setOpenQuestionModal(true);
    setOpenViewQuestionsModal(false);
  };

  const handleOpenEditQuestionModal = (survey, question) => {
    if (!survey || !question) return;

    setSelectedSurvey(survey);
    setSelectedQuestion(question);
    setEditQuestionForm({
      title: question.title,
      module: question.module,
      answers: [...question.answers],
    });
    setOpenEditQuestionModal(true);
  };

   const fetchSurveyQuestions = async (surveyId) => {
  if (!surveyId) return;
  setLoadingQuestions(true);
  try {
    const response = await api.get(`/api/support/survey-questions/${surveyId}`);
    const data = response.data;  

    if (response.status === 200) {
      const questionsMap = {};
      data.forEach((item) => {
        if (!questionsMap[item.QuestionId]) {
          questionsMap[item.QuestionId] = {
            ...item,
            options: [],
          };
        }

        if (item.OptionId) {
          questionsMap[item.QuestionId].options.push({
            OptionId: item.OptionId,
            optionText: item.optionText,
            isActive: item.isActive,
            displayOrder: item.displayOrder,
            OptionCreatedOn: item.OptionCreatedOn,
            OptionCreatedBy: item.OptionCreatedBy,
          });
        }
      });

      const grouped = Object.values(questionsMap);
      setSurveyData({
        SurveyTitle: data[0]?.SurveyTitle,
        SurveyDescription: data[0]?.SurveyDescription,
      });
      setGroupedQuestions(grouped);
    } else {
      throw new Error(data.message || "Failed to fetch questions");
    }
  } catch (error) {
    console.error("Error fetching questions:", error);
    handleSnackbarOpen(error.message, "error");
  } finally {
    setLoadingQuestions(false);
  }
};

  const handleOpenViewQuestionsModal = (survey) => {
    setSelectedSurvey(survey);
    fetchSurveyQuestions(survey.id);
    setOpenViewQuestionsModal(true);
    setOpenSurveyModal(false);
  };

  const handleOpenAnswersModal = (survey, question) => {
    setSelectedSurvey(survey);
    setSelectedQuestion(question);
    setAnswers([...question.answers]);
    setOpenAnswersModal(true);
  };
  const indexOfLastSurvey = currentPage * surveysPerPage;
  const indexOfFirstSurvey = indexOfLastSurvey - surveysPerPage;
  const currentSurveys = filteredSurveys.slice(
    indexOfFirstSurvey,
    indexOfLastSurvey
  );

  return (
    <MainContainer>
      <AppBar
        position="fixed"
        sx={{
          backgroundImage: "linear-gradient(195deg, #0a2e52 0%, #1565C0 200%)",
          boxShadow:
            "0 4px 20px 0 rgba(0, 0, 0, 0.14), 0 7px 10px -5px rgba(0, 0, 0, 0.4)",
          zIndex: (theme) => theme.zIndex.drawer + 1,
          left: collapsed ? "80px" : "280px",
          width: `calc(100% - ${collapsed ? "80px" : "280px"})`,
          transition: theme.transitions.create(["width", "left"], {
            easing: theme.transitions.easing.easeInOut,
            duration: theme.transitions.duration.standard,
          }),
          [theme.breakpoints.down("sm")]: {
            left: 0,
            width: "100%",
          },
        }}
      >
        <Toolbar sx={{ justifyContent: "space-between" }}>
          <Typography variant="h6" noWrap sx={{ fontWeight: 600 }}>
            IPPIS SUPPORT PORTAL
          </Typography>
          <IconButton color="inherit">
            <Badge color="error">
              <NotificationsIcon />
            </Badge>
          </IconButton>
        </Toolbar>
      </AppBar>

      <LeftToolbar
        selectedMenu={selectedMenu}
        onSelectMenu={setSelectedMenu}
        onCollapse={setCollapsed}
      />

      <MainContent $collapsed={collapsed}>
        <Toolbar />

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 2,
          }}
        >
          <TextField
            placeholder="Search Surveys..."
            label="Search Surveys..."
            variant="outlined"
            size="small"
            fullWidth
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            sx={{
              width: isMobile ? "100%" : 400,
              "& .MuiOutlinedInput-root": {
                borderRadius: "12px",
              },
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon color="action" />
                </InputAdornment>
              ),
            }}
          />
          <Tooltip title="Create new survey">
            <Button
              variant="contained"
              color="primary"
              onClick={handleOpenCreateSurveyModal}
              startIcon={<AddIcon />}
              size={isMobile ? "small" : "medium"}
            >
              {isMobile ? "Create" : "Create New"}
            </Button>
          </Tooltip>
        </Box>

        <Box sx={{ flex: 1, p: 2, bgcolor: "#f8f9fa", borderRadius: 2 }}>
          <Box
            sx={{
              backgroundColor: "white",
              borderRadius: "16px",
              p: 3,
              mb: 3,
              boxShadow: "0 4px 20px rgba(0, 0, 0, 0.05)",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 3,
              }}
            >
              <Typography variant="h6" sx={{ fontWeight: 600 }}>
                Survey Management
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {filteredSurveys.length} Surveys found
              </Typography>
            </Box>

            <ResponsiveTableContainer component={Paper}>
              <Table size={isMobile ? "small" : "medium"}>
                <TableHead>
                  <TableRow
                    sx={{
                      bgcolor: theme.palette.primary.light,
                      "& th": {
                        color: "white",
                        fontWeight: 600,
                        whiteSpace: "nowrap",
                        position: "sticky",
                        top: 0,
                        zIndex: 1,
                      },
                    }}
                  >
                    {[
                      "Title",
                      "Module",
                      "Description",
                      "Start Date",
                      "End Date",
                      "Actions",
                    ].map((head) => (
                      <ModernTableCell key={head}>{head}</ModernTableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {loading ? (
                    <TableRow>
                      <ModernTableCell
                        colSpan={5}
                        align="center"
                        sx={{ py: 4 }}
                      >
                        <CircularProgress size={24} />
                        <Typography variant="body2" sx={{ mt: 1 }}>
                          Loading surveys...
                        </Typography>
                      </ModernTableCell>
                    </TableRow>
                  ) : filteredSurveys?.length > 0 ? (
                    filteredSurveys.map((survey) => (
                      <StyledTableRow key={survey.id} hover>
                        <ModernTableCell>
                          <Typography fontWeight="medium">
                            {survey.title}
                          </Typography>
                        </ModernTableCell>
                        <ModernTableCell>
                          <Typography fontWeight="medium">
                            {survey.moduleName}
                          </Typography>
                        </ModernTableCell>

                        <ModernTableCell>
                          <Typography variant="body2">
                            {survey?.descriptions?.length > 100
                              ? `${survey.descriptions.substring(0, 95)}...`
                              : survey.descriptions || "No description"}
                          </Typography>
                        </ModernTableCell>
                        <ModernTableCell>
                          {new Date(survey.startOn).toLocaleString([], {
                            year: "numeric",
                            month: "short",
                            day: "numeric",
                          })}
                        </ModernTableCell>
                        <ModernTableCell>
                          {" "}
                          {new Date(survey.endOn).toLocaleString([], {
                            year: "numeric",
                            month: "short",
                            day: "numeric",
                          })}
                        </ModernTableCell>

                        <ModernTableCell align="right">
                          <Tooltip title="View Survey">
                            <IconButton
                              size="small"
                              color="primary"
                              onClick={() => handleOpenEditSurveyModal(survey)}
                              sx={{
                                "&:hover": {
                                  backgroundColor: alpha(
                                    theme.palette.primary.main,
                                    0.1
                                  ),
                                },
                                mr: 1,
                              }}
                            >
                              <VisibilityIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        </ModernTableCell>
                      </StyledTableRow>
                    ))
                  ) : (
                    <TableRow>
                      <ModernTableCell
                        colSpan={5}
                        align="center"
                        sx={{ py: 4 }}
                      >
                        <Typography variant="body1">
                          No surveys found
                        </Typography>
                      </ModernTableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </ResponsiveTableContainer>
          </Box>

          <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
            <Pagination
              count={Math.ceil(filteredSurveys.length / surveysPerPage)}
              page={currentPage}
              onChange={(e, value) => setCurrentPage(value)}
              color="primary"
              size={isMobile ? "small" : "medium"}
            />
          </Box>
        </Box>
      </MainContent>

      {/* Create/Edit Survey Modal */}
      <Modal
        open={openSurveyModal}
        onClose={() => setOpenSurveyModal(false)}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{ timeout: 500 }}
        sx={{
          backgroundColor: "rgba(0, 0, 0, 0.6)"
        }}
      >
        <Fade in={openSurveyModal}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              bgcolor: "white",
              borderRadius: 3,
              boxShadow:
                "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
              width: isMobile ? "95%" : 700,
              maxHeight: "95vh",
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
            }}
          >
            {/* Header Section */}
            <Box
              sx={{
                bgcolor: "primary.main",
                color: "white",
                p: 3,
                position: "relative",
                "&::before": {
                  content: '""',
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  background:
                    "linear-gradient(135deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.05) 100%)",
                  pointerEvents: "none",
                },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  position: "relative",
                  zIndex: 1,
                }}
              >
                <Box>
                  <Typography
                    variant="h5"
                    fontWeight="700"
                    sx={{
                      mb: 0.5,
                      letterSpacing: "0.02em",
                    }}
                  >
                    {selectedSurvey ? "Edit Survey" : "Create New Survey"}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      opacity: 0.9,
                      fontWeight: 400,
                    }}
                  >
                    {selectedSurvey
                      ? "Update survey details and manage questions"
                      : "Configure your survey settings and add questions"}
                  </Typography>
                </Box>
                <IconButton
                  onClick={() => setOpenSurveyModal(false)}
                  sx={{
                    color: "white",
                    backgroundColor: "rgba(255, 255, 255, 0.1)",
                    "&:hover": {
                      backgroundColor: "rgba(255, 255, 255, 0.2)",
                      transform: "scale(1.05)",
                    },
                    transition: "all 0.2s ease-in-out",
                  }}
                >
                  <CloseIcon />
                </IconButton>
              </Box>
            </Box>

            {/* Content Section */}
            <Box
              sx={{
                flex: 1,
                overflow: "auto",
                p: 4,
                display: "flex",
                flexDirection: "column",
                gap: 3,
              }}
            >
              {/* Survey Information Card */}
              <Box
                sx={{
                  backgroundColor: "#f8fafc",
                  borderRadius: 2,
                  p: 3,
                  border: "1px solid #e2e8f0",
                }}
              >
                <Typography
                  variant="h6"
                  fontWeight="600"
                  sx={{
                    mb: 2.5,
                    color: "#1e293b",
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                  }}
                >
                  📝 Survey Information
                </Typography>

                <Box
                  sx={{ display: "flex", flexDirection: "column", gap: 2.5 }}
                >
                  <TextField
                    fullWidth
                    label="Survey Title"
                    name="title"
                    value={surveyForm.title}
                    onChange={handleSurveyFormChange}
                    required
                    variant="outlined"
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 2,
                        backgroundColor: "white",
                        "&:hover": {
                          "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#3b82f6",
                          },
                        },
                      },
                    }}
                  />

                  <Select
                    fullWidth
                    name="module"
                    value={surveyForm.module}
                    onChange={handleSurveyFormChange}
                    displayEmpty
                    error={formErrors.module}
                    sx={{
                      borderRadius: 2,
                      backgroundColor: "white",
                      "&:hover": {
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#3b82f6",
                        },
                      },
                    }}
                    renderValue={(selected) => {
                      if (!selected) {
                        return (
                          <em
                            style={{
                              color: formErrors.module
                                ? "#f44336"
                                : "rgba(0, 0, 0, 0.6)",
                            }}
                          >
                            Select Module
                          </em>
                        );
                      }
                      return (
                        categories.find((c) => c.id === selected)
                          ?.categoryName || selected
                      );
                    }}
                  >
                    <MenuItem value="" disabled>
                      Select Module
                    </MenuItem>
                    {loading ? (
                      <MenuItem disabled>Loading...</MenuItem>
                    ) : (
                      categories.map((category) => (
                        <MenuItem key={category.id} value={category.id}>
                          {category.categoryName}
                        </MenuItem>
                      ))
                    )}
                  </Select>

                  <TextField
                    fullWidth
                    label="Description"
                    name="description"
                    value={surveyForm.description}
                    onChange={handleSurveyFormChange}
                    multiline
                    rows={3}
                    variant="outlined"
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 2,
                        backgroundColor: "white",
                        "&:hover": {
                          "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#3b82f6",
                          },
                        },
                      },
                    }}
                  />
                </Box>
              </Box>

              {/* Schedule Card */}
              <Box
                sx={{
                  backgroundColor: "#f0f9ff",
                  borderRadius: 2,
                  p: 3,
                  border: "1px solid #bae6fd",
                }}
              >
                <Typography
                  variant="h6"
                  fontWeight="600"
                  sx={{
                    mb: 2.5,
                    color: "#0c4a6e",
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                  }}
                >
                  📅 Survey Schedule
                </Typography>

                <Box
                  sx={{
                    display: "flex",
                    gap: 2,
                    flexDirection: isMobile ? "column" : "row",
                  }}
                >
                  <TextField
                    fullWidth
                    label="Start Date"
                    name="startDate"
                    type="date"
                    value={surveyForm.startDate}
                    onChange={handleSurveyFormChange}
                    required
                    InputLabelProps={{ shrink: true }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <EventIcon sx={{ color: "#3b82f6" }} />
                        </InputAdornment>
                      ),
                    }}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 2,
                        backgroundColor: "white",
                        "&:hover": {
                          "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#3b82f6",
                          },
                        },
                      },
                    }}
                  />
                  <TextField
                    fullWidth
                    label="End Date"
                    name="endDate"
                    type="date"
                    value={surveyForm.endDate}
                    onChange={handleSurveyFormChange}
                    required
                    InputLabelProps={{ shrink: true }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <EventIcon sx={{ color: "#3b82f6" }} />
                        </InputAdornment>
                      ),
                    }}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 2,
                        backgroundColor: "white",
                        "&:hover": {
                          "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#3b82f6",
                          },
                        },
                      },
                    }}
                  />
                </Box>
              </Box>

              {/* Actions Card - Only show when editing */}
              {selectedSurvey && (
                <Box
                  sx={{
                    backgroundColor: "#fefce8",
                    borderRadius: 2,
                    p: 3,
                    border: "1px solid #fde047",
                  }}
                >
                  <Typography
                    variant="h6"
                    fontWeight="600"
                    sx={{
                      mb: 2.5,
                      color: "#a16207",
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                    }}
                  >
                    ⚙️ Survey Management
                  </Typography>

                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns: isMobile
                        ? "1fr"
                        : "repeat(auto-fit, minmax(180px, 1fr))",
                      gap: 2,
                    }}
                  >
                    <Button
                      variant="outlined"
                      color="info"
                      startIcon={<VisibilityIcon />}
                      onClick={() =>
                        handleOpenViewQuestionsModal(selectedSurvey)
                      }
                      fullWidth
                      sx={{
                        borderRadius: 2,
                        py: 1.5,
                        fontWeight: 600,
                        textTransform: "none",
                        borderWidth: 2,
                        "&:hover": {
                          borderWidth: 2,
                          transform: "translateY(-1px)",
                          boxShadow: "0 4px 12px rgba(59, 130, 246, 0.15)",
                        },
                        transition: "all 0.2s ease-in-out",
                      }}
                    >
                      View Questions
                    </Button>

                    {/* REPLACE THIS BUTTON WITH THE NEW COMPONENT */}
                    <UploadQuestionsButton
                      selectedSurvey={selectedSurvey}
                      onUploadSuccess={() => {
                        // Add your refresh logic here
                        // For example: fetchSurveyQuestions() or refetch survey data
                        handleSnackbarOpen(
                          "Questions uploaded successfully!",
                          "success"
                        );
                      }}
                      handleSnackbarOpen={handleSnackbarOpen}
                    />

                    <Button
                      variant="outlined"
                      color="success"
                      startIcon={<LinkIcon />}
                      // onClick={handleGenerateSurveyLink}
                      fullWidth
                      sx={{
                        borderRadius: 2,
                        py: 1.5,
                        fontWeight: 600,
                        textTransform: "none",
                        borderWidth: 2,
                        "&:hover": {
                          borderWidth: 2,
                          transform: "translateY(-1px)",
                          boxShadow: "0 4px 12px rgba(34, 197, 94, 0.15)",
                        },
                        transition: "all 0.2s ease-in-out",
                      }}
                    >
                      Generate Link
                    </Button>

                    <Button
                      variant="outlined"
                      color="error"
                      startIcon={<DeleteIcon />}
                      onClick={() => handleDeleteClick(selectedSurvey)}
                      fullWidth
                      sx={{
                        borderRadius: 2,
                        py: 1.5,
                        fontWeight: 600,
                        textTransform: "none",
                        borderWidth: 2,
                        "&:hover": {
                          borderWidth: 2,
                          transform: "translateY(-1px)",
                          boxShadow: "0 4px 12px rgba(239, 68, 68, 0.15)",
                        },
                        transition: "all 0.2s ease-in-out",
                      }}
                    >
                      Delete Survey
                    </Button>
                  </Box>
                </Box>
              )}
            </Box>

            {/* Footer Section */}
            <Box
              sx={{
                borderTop: "1px solid #e2e8f0",
                backgroundColor: "#f8fafc",
                p: 3,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: 2,
              }}
            >
              <Typography
                variant="caption"
                sx={{
                  color: "#64748b",
                  fontStyle: "italic",
                }}
              >
                {selectedSurvey
                  ? "Make changes and click Update to save"
                  : "Fill in the details and click Create to proceed"}
              </Typography>

              <Box sx={{ display: "flex", gap: 2 }}>
                <Button
                  variant="outlined"
                  onClick={() => setOpenSurveyModal(false)}
                  sx={{
                    borderRadius: 2,
                    px: 3,
                    py: 1.5,
                    fontWeight: 600,
                    textTransform: "none",
                    borderColor: "#d1d5db",
                    color: "#6b7280",
                    "&:hover": {
                      borderColor: "#9ca3af",
                      backgroundColor: "#f9fafb",
                    },
                  }}
                >
                  Cancel
                </Button>

                <Button
                  variant="contained"
                  onClick={
                    selectedSurvey ? handleEditSurvey : handleCreateSurvey
                  }
                  disabled={loading}
                  startIcon={
                    loading ? (
                      <CircularProgress size={20} color="inherit" />
                    ) : selectedSurvey ? (
                      <EditIcon />
                    ) : (
                      <AddIcon />
                    )
                  }
                  sx={{
                    borderRadius: 2,
                    px: 4,
                    py: 1.5,
                    fontWeight: 600,
                    textTransform: "none",
                    background:
                      "linear-gradient(135deg, #3b82f6 0%, #1e40af 100%)",
                    boxShadow: "0 4px 14px 0 rgba(59, 130, 246, 0.3)",
                    "&:hover": {
                      background:
                        "linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)",
                      boxShadow: "0 6px 20px 0 rgba(59, 130, 246, 0.4)",
                      transform: "translateY(-1px)",
                    },
                    "&:disabled": {
                      background: "#e5e7eb",
                      color: "#9ca3af",
                      boxShadow: "none",
                    },
                    transition: "all 0.2s ease-in-out",
                  }}
                >
                  {loading
                    ? "Processing..."
                    : selectedSurvey
                    ? "Update Survey"
                    : "Create Survey"}
                </Button>
              </Box>
            </Box>
          </Box>
        </Fade>
      </Modal>

      {/* Create New Question Modal */}

      <Modal
        open={openQuestionModal}
        onClose={() => setOpenQuestionModal(false)}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{ timeout: 500 }}
        sx={{
          backgroundColor: "rgba(0, 0, 0, 0.6)"
        }}
      >
        <Fade in={openQuestionModal}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              bgcolor: "white",
              p: 3,
              borderRadius: 2,
              boxShadow: 24,
              width: isMobile ? "90%" : 500,
              maxHeight: "90vh",
              overflow: "auto",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 2,
              }}
            >
              <Typography variant="h6" fontWeight="bold">
                Create New Survey Question
              </Typography>
              <IconButton onClick={() => setOpenQuestionModal(false)}>
                <CloseIcon />
              </IconButton>
            </Box>

            <TextField
              label="Question Title"
              fullWidth
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              sx={{ mb: 2 }}
              required
              placeholder="Enter the question (e.g., How would you rate our system?)"
            />

            <Typography
              variant="subtitle1"
              sx={{ mb: 2, fontWeight: "medium" }}
            >
              Answer Options
            </Typography>

            {newQuestionAnswers.map((answer, index) => (
              <Box
                key={answer.id}
                sx={{ display: "flex", alignItems: "center", mb: 2 }}
              >
                <Box sx={{ mr: 1, color: "text.secondary" }}>
                  <RadioButtonCheckedIcon fontSize="small" />
                </Box>
                <TextField
                  fullWidth
                  label={`Option ${index + 1}`}
                  value={answer.text}
                  onChange={(e) =>
                    handleNewAnswerTextChange(answer.id, e.target.value)
                  }
                  size="small"
                  required
                />
                <IconButton
                  color="error"
                  onClick={() => handleRemoveNewAnswer(answer.id)}
                  disabled={newQuestionAnswers.length === 1}
                >
                  <DeleteIcon />
                </IconButton>
              </Box>
            ))}

            <Button
              startIcon={<AddIcon />}
              onClick={handleAddNewAnswer}
              variant="outlined"
              size="small"
              sx={{ mt: 1, mb: 3 }}
            >
              Add Option
            </Button>

            <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
              <Button
                variant="contained"
                color="primary"
                onClick={handleCreateSurveyQuestion}
                disabled={
                  loading ||
                  !title ||
                  newQuestionAnswers.some((a) => !a.text.trim())
                }
                startIcon={
                  loading ? <CircularProgress size={20} /> : <AddIcon />
                }
              >
                {loading ? "Creating..." : "Create Question"}
              </Button>
            </Box>
          </Box>
        </Fade>
      </Modal>

      {/* Edit Question Modal */}
      <Modal
        open={openEditQuestionModal}
        onClose={() => {
          setOpenEditQuestionModal(false);
        }}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{ timeout: 500 }}
        sx={{
           backgroundColor: "rgba(0, 0, 0, 0.6)"
        }}
      >
        <Fade in={openEditQuestionModal}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              bgcolor: "white",
              p: 3,
              borderRadius: 2,
              boxShadow: 24,
              width: isMobile ? "90%" : 500,
              maxHeight: "90vh",
              overflow: "auto",
            }}
          >
            {/* Modal Header */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 2,
                bgcolor: "primary.dark",
                color: "white",
                p: 2,
                borderRadius: "4px",
              }}
            >
              <Typography variant="h6" fontWeight="bold">
                Edit Question
              </Typography>
              <IconButton
                onClick={() => setOpenEditQuestionModal(false)}
                size="small"
                sx={{ color: "white" }}
              >
                <CloseIcon />
              </IconButton>
            </Box>

            <Typography variant="subtitle1" sx={{ mb: 1 }}>
              Survey: {selectedSurvey?.title}
            </Typography>

            {/* Question Title */}
            <TextField
              fullWidth
              label="Question Title"
              name="questionText"
              value={editingQuestion?.questionText || ""}
              onChange={(e) =>
                setEditingQuestion({
                  ...editingQuestion,
                  questionText: e.target.value,
                })
              }
              required
              sx={{ mb: 2 }}
            />

            {/* Module Selection */}
            <Select
              fullWidth
              name="moduleId"
              value={editingQuestion?.moduleId || ""}
              onChange={(e) =>
                setEditingQuestion({
                  ...editingQuestion,
                  moduleId: e.target.value,
                })
              }
              displayEmpty
              required
              sx={{ mb: 2 }}
            >
              <MenuItem value="" disabled>
                Select Module
              </MenuItem>
              {categories.map((cat) => (
                <MenuItem key={cat.id} value={cat.id}>
                  {cat.categoryName}
                </MenuItem>
              ))}
            </Select>

            {/* Answer Options Section */}
            <Typography
              variant="subtitle1"
              sx={{ mb: 2, fontWeight: "medium" }}
            >
              Answer Options
            </Typography>

            {editingQuestion?.options?.map((answer, index) => (
              <Box
                key={answer.id}
                sx={{ display: "flex", alignItems: "center", mb: 2 }}
              >
                <Box sx={{ mr: 1, color: "text.secondary" }}>
                  <RadioButtonCheckedIcon fontSize="small" />
                </Box>
                <TextField
                  fullWidth
                  label={`Option ${index + 1}`}
                  value={answer.optionText || ""}
                  onChange={(e) => {
                    const updatedOptions = [...editingQuestion.options];
                    updatedOptions[index] = {
                      ...updatedOptions[index],
                      optionText: e.target.value,
                    };
                    setEditingQuestion({
                      ...editingQuestion,
                      options: updatedOptions,
                    });
                  }}
                  size="small"
                  required
                />
                <IconButton
                  color="error"
                  onClick={() => {
                    const filteredOptions = editingQuestion.options.filter(
                      (opt) => opt.id !== answer.id
                    );
                    setEditingQuestion({
                      ...editingQuestion,
                      options: filteredOptions,
                    });
                  }}
                  disabled={editingQuestion.options.length <= 1}
                  sx={{ ml: 1 }}
                >
                  <DeleteIcon />
                </IconButton>
              </Box>
            ))}

            <Button
              startIcon={<AddIcon />}
              onClick={() => {
                setEditingQuestion({
                  ...editingQuestion,
                  options: [
                    ...editingQuestion.options,
                    {
                      id: Date.now(), // temporary ID
                      optionText: "",
                      isCorrect: false,
                    },
                  ],
                });
              }}
              variant="outlined"
              size="small"
              sx={{ mt: 1, mb: 3 }}
            >
              Add Option
            </Button>

            {/* Action Buttons */}
            <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
              <Button
                variant="outlined"
                onClick={() => setOpenEditQuestionModal(false)}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={() => handleUpdateQuestion(editingQuestion)}
                disabled={loading}
                startIcon={
                  loading ? <CircularProgress size={20} /> : <EditIcon />
                }
              >
                {loading ? "Saving..." : "Save Changes"}
              </Button>
            </Box>
          </Box>
        </Fade>
      </Modal>

      {/* View Questions Modal */}
      <Modal
        open={openViewQuestionsModal}
        onClose={() => {
          setOpenViewQuestionsModal(false);
        }}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{ timeout: 500 }}
        sx={{
          backgroundColor: "rgba(0, 0, 0, 0.6)"
        }}
      >
        <Fade in={openViewQuestionsModal}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              bgcolor: "white",
              p: 3,
              borderRadius: 2,
              boxShadow: 24,
              width: isMobile ? "90%" : 800,
              maxHeight: "90vh",
              overflow: "auto",
            }}
          >
            {loadingQuestions ? (
              <Box sx={{ display: "flex", justifyContent: "center", p: 4 }}>
                <CircularProgress />
              </Box>
            ) : surveyData ? (
              <>
                {/* Survey Header */}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mb: 3,
                    bgcolor: "primary.main",
                    color: "white",
                    p: 2,
                    borderRadius: 1,
                  }}
                >
                  <Box>
                    <Typography variant="h6" fontWeight="bold">
                      {surveyData.SurveyTitle}
                    </Typography>
                    <Typography variant="body2">
                      {surveyData.SurveyDescription}
                    </Typography>
                  </Box>
                  <IconButton
                    onClick={() => setOpenViewQuestionsModal(false)}
                    size="small"
                    sx={{ color: "white" }}
                  >
                    <CloseIcon />
                  </IconButton>
                </Box>

                {/* Questions List */}
                {groupedQuestions.length > 0 ? (
                  <Box sx={{ mb: 3 }}>
                    <Typography
                      variant="subtitle1"
                      sx={{ mb: 2, fontWeight: "medium" }}
                    >
                      Survey Questions ({groupedQuestions.length})
                    </Typography>

                    {groupedQuestions.map((question, index) => (
                      <Card
                        key={question.QuestionId}
                        sx={{
                          mb: 2,
                          borderLeft: `4px solid ${theme.palette.primary.main}`,
                          transition: "transform 0.2s",
                          "&:hover": {
                            transform: "translateY(-2px)",
                            boxShadow: 3,
                          },
                        }}
                      >
                        <CardContent>
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "flex-start",
                            }}
                          >
                            <Box>
                              <Typography
                                variant="subtitle1"
                                fontWeight="medium"
                              >
                                {index + 1}. {question.questionText}
                              </Typography>
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  mt: 0.5,
                                  gap: 1,
                                }}
                              >
                                <Chip
                                  label={question.questionType}
                                  size="small"
                                  color="primary"
                                />
                                {question.isRequired && (
                                  <Chip
                                    label="Required"
                                    size="small"
                                    color="secondary"
                                  />
                                )}
                                <Typography
                                  variant="caption"
                                  color="text.secondary"
                                >
                                  Created:{" "}
                                  {new Date(
                                    question.QuestionCreatedOn
                                  ).toLocaleDateString()}
                                </Typography>
                              </Box>
                            </Box>
                            <Box>
                              <Tooltip title="Edit Question">
                                <IconButton
                                  size="small"
                                  color="primary"
                                  onClick={() => handleEditQuestion(question)}
                                  sx={{ mr: 1 }}
                                >
                                  <EditIcon fontSize="small" />
                                </IconButton>
                              </Tooltip>
                              <Tooltip title="Delete Question">
                                <IconButton
                                  size="small"
                                  color="error"
                                  onClick={() =>
                                    handleDeleteSurveyQuestionClick(question)
                                  }
                                >
                                  <DeleteIcon fontSize="small" />
                                </IconButton>
                              </Tooltip>
                            </Box>
                          </Box>

                          <Divider sx={{ my: 1.5 }} />

                          {question.options.length > 0 ? (
                            <>
                              <Typography variant="subtitle2" sx={{ mb: 1 }}>
                                Answer Options:
                              </Typography>
                              <List dense>
                                {question.options.map((option) => (
                                  <ListItem
                                    key={option.OptionId}
                                    sx={{
                                      py: 0.5,
                                      "&:hover": {
                                        backgroundColor:
                                          theme.palette.action.hover,
                                      },
                                    }}
                                  >
                                    <ListItemIcon>
                                      {question.questionType.toLowerCase() ===
                                      "radio" ? (
                                        <RadioButtonCheckedIcon color="action" />
                                      ) : (
                                        <CheckBoxIcon color="action" />
                                      )}
                                    </ListItemIcon>
                                    <ListItemText
                                      primary={option.optionText}
                                      secondary={`Order: ${option.displayOrder}`}
                                    />
                                    {!option.isActive && (
                                      <Chip
                                        label="Inactive"
                                        size="small"
                                        color="error"
                                        sx={{ ml: 1 }}
                                      />
                                    )}
                                  </ListItem>
                                ))}
                              </List>
                            </>
                          ) : (
                            <Typography variant="body2" color="text.secondary">
                              No answer options defined
                            </Typography>
                          )}
                        </CardContent>
                      </Card>
                    ))}
                  </Box>
                ) : (
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      py: 4,
                      textAlign: "center",
                    }}
                  >
                    <HelpOutlineIcon
                      sx={{ fontSize: 60, color: "text.disabled", mb: 1 }}
                    />
                    <Typography variant="body1" color="textSecondary">
                      No questions found for this survey
                    </Typography>
                  </Box>
                )}

                {/* Footer Actions */}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    mt: 3,
                    pt: 2,
                    borderTop: `1px solid ${theme.palette.divider}`,
                  }}
                >
                  <Button
                    variant="outlined"
                    onClick={() => setOpenViewQuestionsModal(false)}
                  >
                    Close
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => handleOpenQuestionModal(selectedSurvey)}
                    startIcon={<AddIcon />}
                  >
                    Add New Question
                  </Button>
                </Box>
              </>
            ) : (
              <Typography color="error">Failed to load survey data</Typography>
            )}
          </Box>
        </Fade>
      </Modal>

      <Modal
        open={openAnswersModal}
        onClose={() => setOpenAnswersModal(false)}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{ timeout: 500 }}
        sx={{
           backgroundColor: "rgba(0, 0, 0, 0.6)"
        }}
      >
        <Fade in={openAnswersModal}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              bgcolor: "white",
              p: 3,
              borderRadius: 2,
              boxShadow: 24,
              width: isMobile ? "90%" : 500,
              maxHeight: "90vh",
              overflow: "auto",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 2,
                bgcolor: "primary.dark",
                color: "white",
                p: 2,
                borderRadius: "4px",
              }}
            >
              <Typography variant="h6" fontWeight="bold">
                Manage Answer Options
              </Typography>
              <IconButton
                onClick={() => setOpenAnswersModal(false)}
                size="small"
                sx={{ color: "white" }}
              >
                <CloseIcon />
              </IconButton>
            </Box>

            <Typography variant="subtitle1" sx={{ mb: 1 }}>
              Question: {selectedQuestion?.title}
            </Typography>

            <Typography
              variant="subtitle1"
              sx={{ mb: 2, fontWeight: "medium" }}
            >
              Answer Options
            </Typography>

            {answers.map((answer, index) => (
              <Box
                key={answer.id}
                sx={{ display: "flex", alignItems: "center", mb: 2 }}
              >
                <Box sx={{ mr: 1, color: "text.secondary" }}>
                  <RadioButtonCheckedIcon fontSize="small" />
                </Box>
                <TextField
                  fullWidth
                  label={`Option ${index + 1}`}
                  value={answer.text}
                  onChange={(e) =>
                    handleAnswerTextChange(answer.id, e.target.value)
                  }
                  size="small"
                  required
                />
                <IconButton
                  color="error"
                  onClick={() => handleRemoveAnswerInManageModal(answer.id)}
                  disabled={answers.length <= 1}
                  sx={{ ml: 1 }}
                >
                  <DeleteIcon />
                </IconButton>
              </Box>
            ))}

            <Button
              startIcon={<AddIcon />}
              onClick={handleAddAnswer}
              variant="outlined"
              size="small"
              sx={{ mt: 1, mb: 3 }}
            >
              Add Option
            </Button>

            <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
              <Button
                variant="outlined"
                onClick={() => setOpenAnswersModal(false)}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={handleSaveAnswers}
                disabled={loading}
                startIcon={
                  loading ? <CircularProgress size={20} /> : <EditIcon />
                }
              >
                {loading ? "Saving..." : "Save Answers"}
              </Button>
            </Box>
          </Box>
        </Fade>
      </Modal>
      
      <NotificationSnackbar
        open={snackbarOpen}
        onClose={handleSnackbarClose}
        message={snackbarMessage}
        severity={snackbarSeverity}
      />
      <ConfirmationDialog
        open={openConfirm}
        handleClose={() => {
          setOpenConfirm(false);
          setSurveyToDelete(null);
        }}
        handleConfirm={handleDeleteConfirm}
        title="Delete Survey"
        content={`Are you sure you want to delete the survey titled: "${surveyToDelete?.title}"?`}
        confirmText="Delete"
        severity="error"
      />
      <ConfirmationDialog
        open={deleteConfirmOpen}
        handleClose={() => {
          setDeleteConfirmOpen(false);
          setQuestionToDelete(null);
        }}
        handleConfirm={() => handleDeleteSurveyQuestion(questionToDelete)}
        title="Delete Survey Question"
        content={`Are you sure you want to delete the question titled: "${questionToDelete?.questionText}"?`}
        confirmText="Delete"
        severity="error"
      />
      <Footer />
    </MainContainer>
  );
}
export default RequestUserFeedBacks;
